<div mat-dialog-content>
  <h2 style="font-size: 22px; font-weight: bold;">{{ data.title }}</h2>

  <ng-container *ngIf="step === 'tarif'">

    <form [formGroup]="demoTarifeForm">
      <div class="formGrid">
        <div class="fullWidth nameInfo">
          <p style="margin-left: 2em">Organisation</p>
          <!-- Check if providers list has items -->
          <ng-container *ngIf="memberships.length; else noOrganizations">
            <mat-form-field>
              <mat-label>Organisation</mat-label>
              <mat-select formControlName="organisation" required>
                <ng-container *ngFor="let provider of memberships">
                  <ng-container *ngIf="provider.role == 'ADMIN'">
                    <mat-option *ngIf="provider.organisationId" [value]="provider.organisationId">{{
                      provider.organisationName }}</mat-option>
                  </ng-container>
                </ng-container>
              </mat-select>
              <mat-error *ngIf="organisation.hasError('required')">Organisation ist erforderlich</mat-error>
            </mat-form-field>
          </ng-container>

          <!-- Template for when no organizations are available -->
          <ng-template #noOrganizations>
            <div class="no-org-container">
              <div class="alert alert-warning">
                <p>Sie können nicht fortfahren, ohne Mitglied einer Organisation zu sein.</p>
              </div>
            </div>
          </ng-template>
        </div>
        <div class="fullWidth nameInfo">
          <p style="margin-left: 2em">Tarif auswählen</p>
          <mat-form-field>
            <mat-label>Tarif</mat-label>
            <mat-select formControlName="tarif" required>
              <mat-option *ngFor="let packet of data.ProductsToShow" [value]="packet.priceId.id">{{ packet.packageClass
                }} / {{ packet.listItems[1].name }}</mat-option>
            </mat-select>
            <mat-error *ngIf="tarif.hasError('required')">Tarif ist erforderlich</mat-error>
          </mat-form-field>
        </div>

        <div class="fullWidth nameInfo">
          <p style="margin-left: 2em">Menge</p>
          <mat-form-field>
            <mat-label>Menge</mat-label>
            <mat-select formControlName="menge" required>
              <mat-option value="1">1</mat-option>
              <mat-option value="2">2</mat-option>
              <mat-option value="3">3</mat-option>
              <mat-option value="4">4</mat-option>
              <mat-option value="5">5</mat-option>
            </mat-select>
            <mat-error *ngIf="menge.hasError('required')">Menge ist erforderlich</mat-error>
          </mat-form-field>
        </div>

        <div class="fullWidth nameInfo">
          <p style="margin-left: 2em">Zahlungsart auswählen</p>
          <mat-form-field>
            <mat-label>Zahlungsart</mat-label>
            <mat-select formControlName="zahlungsart" required>
              <ng-container *ngFor="let card of paymentDatas">
                <ng-container *ngIf="card.type=='card'">
                  <mat-option [value]="card.id">{{ card.cardHolder }} / **** **** **** {{ card.card.last4
                    }}</mat-option>
                </ng-container>
                <ng-container *ngIf="card.type=='link'">
                  <mat-option [value]="card.id">{{ card.cardHolder }} / Link</mat-option>
                </ng-container>
              </ng-container>
            </mat-select>
            <mat-error *ngIf="zahlungsart.hasError('required')">Zahlungsart ist erforderlich</mat-error>
          </mat-form-field>
        </div>

        <div class="fullWidth nameInfo">
          <p style="margin-left: 2em">Promo-Code</p>
          <mat-form-field>
            <mat-label>Promo-Code</mat-label>
            <input matInput formControlName="vouchercode">
            <mat-error *ngIf="vouchercode.hasError('invalidVoucher')">
              Promo-Code ist nicht gültig
            </mat-error>
          </mat-form-field>
        </div>

      </div>
      <div class="Width" mat-dialog-actions>
        <!-- <app-hexagon-button-text-icon
      [text]="'Validierung des Promocodes'"
      [icon]="'/assets/img/hochladen.png'"
      (click)="checkDiscount()"
    >
    </app-hexagon-button-text-icon> -->
        <app-hexagon-button-text-icon [text]="'Neue Organisation anlegen​'" [icon]="'/assets/img/hochladen.png'"
          [width]="1.5" (click)="addNewOrganization()">
        </app-hexagon-button-text-icon>

        <app-hexagon-button-text-icon [text]="'Neue Zahlungsmethode hinzufügen'" [icon]="'/assets/img/icons/svg/plus.svg'"
          [width]="1.5" (click)="addPaymentMethod()">
        </app-hexagon-button-text-icon>
      </div>

      <div mat-dialog-actions>
        <button style="width: 125px" matButton="elevated" color="warn" *ngIf="showForm" (click)="cancel()">
          Abbrechen
        </button>
        <button matButton="elevated" class="green-confirm" style="width: 125px" (click)="goToCheckout()">Weiter</button>
      </div>
    </form>

  </ng-container>


  <ng-container *ngIf="step === 'checkout'">

    <div class="bg-summary">
      <h3 class="product-name">{{ selectedPacket.productName }} abonnieren</h3>
      <div class="price-highlight">
        <span class="amount">{{ monthlySubtotal }}</span>
        <span class="per">pro Monat</span>
      </div>

      <div class="price-summary-container">
        <img src="assets/svg-icons/bimswarmLogo.svg" alt="BIMSWARM Logo" class="logo-img">
        <div class="price-summary">
          <div class="summary-row">
            <div>
              <span class="ft-wt-500">{{ selectedPacket.productName }}</span>
              <div class="product-meta">Menge {{ menge.value }} · Jährlich abgerechnet</div>
            </div>
            <span class="ft-wt-500">
              {{ unitAmount }}
            </span>
          </div>

          <div class="sep-line"></div>

          <div class="summary-row">
            <span class="ft-wt-500">Zwischensumme</span>
            <span class="ft-wt-500">{{ subtotalBeforeDiscount }}</span>
          </div>
          <div class="summary-row" *ngIf="discountPercent > 0">
            <span class="ft-wt-500">Rabatt ({{ discountPercent }} %)</span>
            <span class="ft-wt-500">- {{discountAmount }}</span>
          </div>
          <div class="summary-row">
            <span>Umsatzsteuer (19 %)</span>
            <span>{{ tax }}</span>
          </div>

          <div class="sep-line"></div>

          <div class="total-row">
            <span>Heute fällige Gesamtsumme</span>
            <span class="total-amount">{{ total }}</span>
          </div>
        </div>
      </div>
    </div>

    <div mat-dialog-actions>
      <button matButton="elevated" class="green-confirm" style="width: 125px" (click)="backToTarif()">Zurück</button>
      <button style="width: 125px" matButton="elevated" class="green-confirm" (click)="onSubmit()"
        [disabled]="demoTarifeForm.invalid" *ngIf="showForm">
        Abonnieren
      </button>
    </div>
  </ng-container>

</div>

<div *ngIf="loading" class="loading-overlay-spinner">
  <mat-spinner></mat-spinner>
</div>